import moment from "moment";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import React, { useEffect, useReducer } from "react";

import Row from "components/Row";
import Page from "components/Page";
import Card from "components/Card/Card";
import NContainer from "components/NContainer";
import HeaderBanner from "components/headerBanner/HeaderBanner";
import { getMyResult, getTop10ResultForExam } from "../firebase";
import FullScreenLoader from "components/Loaders/FullScreenLoader";
import { getPaper, getExamById } from "modules/exam/examQuiz/firebase";

const initialState = {
  paper: null,
  userResult: null,
  exam: null,
  loading: true,
  top10: []
};
function reducer(state, action) {
  switch (action.type) {
    case "fetch_paper":
      return { ...state, paper: action.payload };
    case "user_result":
      return { ...state, userResult: action.payload };
    case "loaded":
      return { ...state, loading: false };
    case "init":
      return {
        ...state,
        paper: action.payload.paper,
        userResult: action.payload.userResult,
        exam: action.payload.exam,
        top10: action.payload.top10,
        loading: false
      };
    default:
      return state;
  }
}

function Result({ match, history }) {
  let key = match.params.key;
  let { authenticated, firestoreUser: user } = useSelector(
    state => state.authState
  );

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    const exam = await getExamById(key);
    const paper = await getPaper(exam.paperKey);
    let userResult = null;
    if (authenticated) {
      userResult = await getMyResult(exam.examKey);
    }
    console.log("@@user", authenticated, userResult);
    let top10 = await getTop10ResultForExam(exam.examKey);
    dispatch({ type: "init", payload: { exam, userResult, paper, top10 } });
  }

  if (state.loading) return <FullScreenLoader />;

  return (
    <React.Fragment>
      <HeaderBanner
        title="Result"
        subtitle="Check the result of exam you appeared."
      />
      <Page>
        {!authenticated && (
          <Row justify="center">
            <Typography variant="h4" style={{ color: "#556879" }}>
              Login to view your result
            </Typography>
          </Row>
        )}
        <NContainer style={{ display: "flex", justifyContent: "center" }}>
          <StudentResult state={state} user={user} />
          <TopCard>
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <h1>Top 10</h1>
              <span
                onClick={() =>
                  history.push(`/all_result/${state.exam.examKey}`)
                }
              >
                View All
              </span>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Marks</th>
                </tr>
              </thead>
              <tbody>
                {state.top10.map(i => (
                  <tr key="i.name">
                    <td>{i.rank}</td>
                    <td>{i.name}</td>
                    <td>{i.score}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TopCard>
        </NContainer>
      </Page>
    </React.Fragment>
  );
}

function StudentResult({ state: { exam, userResult: result, paper }, user }) {
  console.log("@@data", result, exam, paper);
  if (!result) return null;
  return (
    <ResultCard>
      <h1>{exam.name}</h1>
      <table>
        <tbody>
          <tr>
            <td>Exam Date</td>
            <td>{moment(exam.startDate).format("DD/MM/YYYY")}</td>
          </tr>
          <tr>
            <td>Student Name</td>
            <td>{user.name}</td>
          </tr>
          <tr>
            <td>Roll No</td>
            <td>{user.roll}</td>
          </tr>
          <tr>
            <td>No. of Questions</td>
            <td>{paper.questionCount}</td>
          </tr>
          <tr>
            <td>Total Marks</td>
            <td>{paper.fullMarks}</td>
          </tr>
          <tr>
            <td>Your Marks</td>
            {console.log("@@result", result)}
            <td>{result.score || 0}</td>
          </tr>
          <tr>
            <td>Percentage</td>
            <td>{(result.score / +paper.fullMarks) * 100}%</td>
          </tr>
          <tr>
            <td>Rank</td>
            <td>3</td>
          </tr>
          <tr>
            <td>Result</td>
            <td>
              <ResultTag status={result.score > +paper.passMarks}>
                {result.score > +paper.passMarks ? "Pass" : "Fail"}
              </ResultTag>
            </td>
          </tr>
        </tbody>
      </table>
    </ResultCard>
  );
}

export default Result;

const ResultTag = styled.span`
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  background: ${props => (props.status ? "#2DBD9C" : "#e87f7f")};
`;

const TopCard = styled(Card)`
  &&& {
    border-radius: 8px;
    padding: 0;
    box-shadow: #ccca 0 0 20px;
    margin: 20px;
    h1 {
      margin: 30px 50px;
      margin-bottom: 20px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      @media (max-width: 420px) {
        font-size: 2em;
      }
    }
    span {
      cursor: pointer;
      text-decoration: underline;
    }
    table {
      border-collapse: collapse;
      tr {
        border-bottom: 1px solid #ccca;
        &:last-child {
          border-bottom: none;
        }
      }
      td,
      th {
        border: 1px solid #ccca;
        border-bottom: none;
        padding: 15px 20px;
        font-size: 1.2em;
        font-weight: 100;
        &:first-child {
          border-left: none;
          text-align: right;
        }
        &:last-child {
          border-right: none;
        }
      }
    }
  }
`;

const ResultCard = styled(Card)`
  &&& {
    border-radius: 8px;
    padding: 0;
    box-shadow: #ccca 0 0 20px;
    margin: 20px;
    h1 {
      margin: 30px 50px;
      margin-bottom: 20px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      @media (max-width: 420px) {
        font-size: 2em;
      }
    }
    table {
      border-collapse: collapse;
      @media (max-width: 420px) {
        display: flex;
        flex-direction: column;
        tr {
          display: flex;
          flex-direction: column;
          text-align: center;
          td:last-child {
            padding-top: 0px;
          }
        }
      }
      tr {
        background: #f8f8f8;
        &:nth-child(2n) {
          background: white;
        }
        td {
          padding: 15px 50px;
          font-size: 1.2em;
          &:nth-child(2) {
            font-weight: bold;
          }
        }
      }
    }
  }
`;
